var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { Loading } from 'elements';
var Tree = /** @class */ (function (_super) {
    __extends(Tree, _super);
    function Tree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderLeaf = function (item, index) {
            var _a = _this.props, level = _a.level, subTreeExtractor = _a.subTreeExtractor, keyExtractor = _a.keyExtractor, renderItem = _a.renderItem, onSelectItem = _a.onSelectItem;
            var handleSelectItem = onSelectItem || (function () { });
            var subTree = subTreeExtractor(item, index) || [];
            var leaf = (React.createElement("div", { key: keyExtractor(item, index), onClick: function () { return handleSelectItem(item); } }, renderItem(item, level)));
            if (subTree.length === 0)
                return leaf;
            return (React.createElement("div", { key: keyExtractor(item, index) },
                leaf,
                React.createElement(Tree, __assign({}, _this.props, { data: subTree, level: level + 1 }))));
        };
        return _this;
    }
    Tree.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, loading = _a.loading;
        if (loading)
            return React.createElement(Loading, null);
        return React.createElement("div", null, data.map(function (item, index) { return _this.renderLeaf(item, index); }));
    };
    Tree.defaultProps = {
        level: 0
    };
    return Tree;
}(Component));
export default Tree;



//////////////////
// WEBPACK FOOTER
// ./src/components/Tree.tsx
// module id = 1064
// module chunks = 0